module.exports = __webpack_public_path__ + "img/2.260b338f.jpg";